/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

export interface CohortPlaylist {
  id: string;
  title: string;
}

export interface CohortDetails {
  startDate: string;
  endDate: string;
  isActive: boolean;
  playlistId?: string;
  playlistTitle?: string;
  playlistType?: string;
  capacity?: number;
  clientId?: string;
  clientName?: string;
  lmsSectionId?: string;
  cohortType?: string;
}

export interface UserGroups {
  title: string;

  _id: string;

  organizationId: string;

  memberCount: number;

  type: string;

  lastUpdatedOn: Date;

  createdAt?: Date;

  metadata?: unknown;

  cohortDetails?: CohortDetails;

  // front-end specific
  isEditing?: boolean;
}

export interface MemberGroups {
  id: string;
  name: string;
  type?: string;
}

export const NotDisplayableGroupTypes = ['STAFF', 'STUDENTS', 'STANDARD'];

/**
 * The label a group type carries in the UI, or `undefined` for the types that carry none.
 * `SUPER_GROUP` and `superGroup` both read as `Super group`.
 */
export function displayableGroupTypeLabel(type: string | undefined): string | undefined {
  if (!type || NotDisplayableGroupTypes.includes(type.toUpperCase())) {
    return undefined;
  }
  const readable = type
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase();
  return readable.charAt(0).toUpperCase() + readable.slice(1);
}

export interface UserGroupMember {
  firstName: string;
  lastName: string;
  email: string;
  uid: string;
  image?: string;
}

export interface CreateUserGroups {
  title: string;
  type?: string;
  cohortConfig?: Partial<CohortDetails>;
}

export interface UserGroupUploadResult {
  processedUsers: string[];
  invitedUsers: string[];
  failedUsers: string[];
  successCount: number;
  failureCount: number;
}
